import React from 'react';

import { Box } from '@mui/material';

import { PeoStaffTableWrapperPeoAdmin } from 'src/components/peoStaff';
import { ResendInviteModal } from 'src/modals/invite';
import { InvitePeoStaffByPeoAdminModal, PeoStaffViewDetailsModal } from 'src/modals/peoStaff';
import { TableDataProvider } from 'src/providers/TableDataProvider';
import type { SxProp } from 'src/types/mui';

export const PeoStaffPagePeoAdmin: React.FC = () => {
  return (
    <React.Fragment>
      <Box sx={containerStyles}>
        <TableDataProvider>
          <PeoStaffTableWrapperPeoAdmin />
        </TableDataProvider>
      </Box>

      <InvitePeoStaffByPeoAdminModal />
      <PeoStaffViewDetailsModal />
      <ResendInviteModal />
    </React.Fragment>
  );
};

const containerStyles: SxProp = theme => ({
  [theme.breakpoints.up('sm')]: {
    display: 'flex',
    flexGrow: 1,
    flexShrink: 1,
    flexBasic: '0%',
    flexDirection: 'column',
    height: '100%',
  },
  [theme.breakpoints.down('sm')]: {
    px: 2,
  },
});
